import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Button, Popover, Typography, Divider, Badge, IconButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/SentimentSatisfied';
import { Reactions } from '../../../models/survey/Reactions';

class BoardPostReactions extends Component {
  state = {
    anchorEl: null,
  };

  handleOpen = event => this.setState({ anchorEl: event.currentTarget });

  handleClose = () => this.setState({ anchorEl: null, });
 
  render() {
    const { id, reactions, onUndoReact, onReact, submitting, signedIn, disabled } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    
    return (
      <React.Fragment>
        {Object.keys(reactions).map(r => reactions[r].count
          ? <Button
              key={r}
              size="small"
              variant={reactions[r].hasReacted ? 'outlined' : 'text'}
              color={reactions[r].hasReacted ? 'primary' : 'default'}
              style={{ marginRight: 4, cursor: !signedIn ? 'default' : 'pointer' }}
              onClick={!signedIn ? null : () => reactions[r].hasReacted ? onUndoReact(r) : onReact(r)}
              disableRipple={!signedIn}
              disabled={submitting || disabled}
              title={!signedIn ? "Zaloguj się aby dodać reakcję" : null}
            >
                {Reactions[r].name} {reactions[r].count}
              </Button>
          : null)}
        {Object.keys(reactions).filter(r => reactions[r].count).length < Object.keys(Reactions).length && signedIn && !disabled
          ? <React.Fragment>
              <IconButton
                disabled={submitting || !signedIn || disabled}
                size="small"
                aria-owns={open ? `${id}-reactions-popover` : undefined}
                aria-haspopup="true"
                onClick={this.handleOpen}
                title="Dodaj reakcję"
              >
                <Badge badgeContent="+" color="default" style={{fontWeight: 600}}>
                  <AddIcon fontSize="small" />
                </Badge>
              </IconButton>
              <Popover
                id={`${id}-reactions-popover`}
                open={open}
                anchorEl={anchorEl}
                onClose={this.handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                disableRestoreFocus
              >
                <div style={{ maxWidth: 202, padding: 5 }}>
                  <Typography variant="caption" gutterBottom>Wybierz reakcję</Typography>
                  <Divider style={{marginBottom: 5}} />
                  {Object.keys(reactions).filter(r => reactions[r].count === 0).map(r => (
                    <Button disabled={submitting} key={r} onClick={() => { this.handleClose(); onReact(r); }}>{Reactions[r].name}</Button>
                  ))}
                </div>
              </Popover>
            </React.Fragment>
        : null}
      </React.Fragment>
    );
  }
}

BoardPostReactions.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  reactions: PropTypes.object.isRequired,
  onReact: PropTypes.func.isRequired,
  onUndoReact: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  signedIn: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default translate()(BoardPostReactions);



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/board/BoardPostReactions.js